<div id="app-container" [ngClass]="{'nightMode' : nightModeService.isNightMode()}">
    <router-outlet></router-outlet>
</div>

<div id="landscape-warning">
  Veuillez tourner votre appareil en mode portrait 📱
</div>